import prism from '@theme-ui/prism/presets/dracula'

export default prism
